import { css } from '@emotion/react';

export const sectionContainer = css`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const sectionHeader = css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 6px;
    background: #667eea;
    color: white;
    border-radius: 8px;
    font-weight: 600;
    font-size: 13px;
    letter-spacing: 0.5px;
`;

export const sectionContent = css`
    padding: 4px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e9ecef;
`;

export const dropdownContainer = css`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const dropdownSelect = css`
    width: 100%;
    padding: 8px 12px;
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    font-size: 11px;
    font-family: 'SCDream4';
    color: #495057;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #667eea;
    }

    &:focus {
        outline: none;
    }
`;

export const divider = css`
    width: 100%;
    height: 1px;
    background: #e9ecef;
    margin: 4px 0;
`;
